module.exports = __webpack_public_path__ + "static/media/kikiray.11a61007.png";